module.exports = __webpack_public_path__ + "static/media/electricmilk.e83185b5.webp";